export default __webpack_public_path__ + "static/media/security-man.82c255e3.svg";